import { DayPicker, type DayPickerProps } from 'react-day-picker';
import 'react-day-picker/style.css';

import { cn } from '@/lib/utils';

/**
 * A month grid, from react-day-picker.
 *
 * The library's own stylesheet is imported and then re-tuned through its CSS
 * variables under `.ed-calendar` (see index.css) rather than every element being
 * re-dressed in Tailwind classes: the parts that need to look like this site are
 * the accent colour, the day size and the closed-day treatment, and the rest is
 * a calendar, which the library already draws correctly.
 *
 * Monday first, matching how the rest of the site reads dates (en-GB) and the
 * order weekday closures are listed in.
 */
export function Calendar({ className, ...props }: DayPickerProps) {
  return (
    <DayPicker
      className={cn('ed-calendar', className)}
      weekStartsOn={1}
      showOutsideDays
      {...props}
    />
  );
}
